import { atom } from "jotai";

export const showOTPFormAtom = atom(false);
